import root from 'window-or-global';
import * as ProductActions from '../../actions/ProductActions';

export function getInitialState () {
  const initialState = root.INITIAL_STATE;
  if (!initialState || (initialState && !Object.keys(initialState).length)) {
    return {};
  }

  const { offer: o } = initialState;

  return {
    isRequesting: false,
    isEditing: false,
    shortUrl: o.short_url,
    shortUrlIdentifier: o.short_url_identifier,
    clonedShortUrlIdentifier: o.short_url_identifier,
    errors: {},
  };
}

const shortUrlForm = (state = getInitialState(), action) => {
  switch (action.type) {
    case ProductActions.EDIT_SHORTURL:
      return {
        ...state,
        shortUrlIdentifier: action.payload.identifier,
        errors: {},
      };

    case ProductActions.RESET_SHORTURL:
      return {
        ...state,
        shortUrlIdentifier: state.clonedShortUrlIdentifier,
        errors: {},
      };

    case ProductActions.CHANGE_IS_SHORTURL_EDITABLE:
      return {
        ...state,
        isEditing: action.payload.isEditing,
      };

    case ProductActions.CHANGE_SHORTURL_REQUEST:
      return {
        ...state,
        isRequesting: true,
      };

    case ProductActions.CHANGE_SHORTURL_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        shortUrlIdentifier: action.response.identifier,
        clonedShortUrlIdentifier: action.response.identifier,
        shortUrl: action.response.shortUrl,
        isEditing: false,
      };

    case ProductActions.CHANGE_SHORTURL_FAILURE:
      return {
        ...state,
        isRequesting: false,
        errors: action.errors,
      };

    default:
      return state;
  }
};

export default shortUrlForm;

export const getShortUrl = state => state.shortUrl;



// WEBPACK FOOTER //
// ./src/product/reducers/product/shortUrlForm.js